export const getVideoDuration = (file: File) =>
  new Promise<number>((resolve, reject) => {
    const video = document.createElement('video')
    video.preload = 'metadata'

    video.addEventListener('loadedmetadata', () => resolve(video.duration))
    video.addEventListener('error', (error) => reject(error))

    video.src = URL.createObjectURL(file)
    video.remove()
  })
